import axios from '@/shared/axios';
import { BaseResponse } from '@/types/web.interface';

// 风险查询
export async function postShadowbanRiskApi(params: any) {
  const res = await axios.post<BaseResponse<any>>('/shadowban/risk', params);
  return res.data;
}
